/*
  Apollo State name for sharing cached data
*/
export const APOLLO_STATE_PROP_NAME = "__APOLLO_STATE__";

/*
  Avro v4 event name for plan change interactions
*/
export const PLAN_CHANGE_EVENT =
  "schema:billing.account.plan.PlanChangeUserInteractionEvent";

/*
  Standard event data for when a geolocated currency is loaded
*/
export const geoCurrencyLoadedEventData = {
  event_action: "select_currency",
  interaction_goal: "select currency",
  interaction_name: "geolocated currency loaded",
};

/*
  Default country code for user geo location provided by Vercel headers
*/
export const DEFAULT_COUNTRY_CODE = "US";

export const DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE = 33;

export const BUILDER_MODELS = {
  pricingFaq: "pricing-faq",
  pricingPageSection: "pricing-page-section",
};

export const BUILDER_UNIQUE_IDENTIFIERS = {
  pricingFaq: "pricing-faq",
};

/**
 * Default account ID to be used Logged Out when /pricing needs a single default behavior
 */
export const DEFAULT_ACCOUNT_ID = "1";

/*
  Builder unique identifiers for the pricing-page-section Model
*/
// Builder pricing page FAQ
export const PRICING_FAQ = "pricing-faq";

/**
 * Split feature flags
 */
export const FEATURE_TABLES_SPLIT_NAME = "revenue_growth_feature-tables-flag";
export const REVENUE_GROWTH_NEW_DOWNGRADE = "revenue_growth_new_downgrade";
export const APRIL_PNP_RELEASE = "april_pnp_release";

/**
 * Default plan group IDs for each environment
 */
export const STAGING_DEFAULT_PG_IDS = [348, 105];
export const PROD_DEFAULT_PG_IDS = [89, 90];

/**
 * Plan IDs for the previous default plan groups
 */
export const PREVIOUS_DEFAULT_PG_94_STAGING_PLAN_IDS = [
  1808, 1806, 1804, 1788, 1786, 1802, 1784, 1828, 1529, 1826, 1824, 1800, 1782,
  1863, 1822, 1780, 1778, 1820, 1528, 1818, 1796, 1794, 1792, 1816, 1776, 1774,
  1814, 1790, 1772, 1812, 1770, 1559, 1810, 1807, 1563, 1805, 1803, 1787, 1785,
  1801, 1783, 1827, 1530, 1825, 1564, 1799, 1781, 1823, 1864, 1821, 1779, 1524,
  1531, 1819, 1777, 1817, 1795, 1793, 1791, 1523, 1775, 1815, 1773, 1813, 1771,
  1789, 1811, 1522, 1769, 1548, 1809, 1521, 1553, 1554, 1520, 1519, 1535, 1536,
  1518, 3195, 1537, 1538, 1539, 1540, 1542, 1541, 1517,
]; // self-serve

export const PREVIOUS_DEFAULT_PG_95_STAGING_PLAN_IDS = [
  1860, 1858, 1856, 1854, 1852, 1850, 1848, 1846, 1844, 1842, 1840, 1838, 1836,
  1834, 1832, 1830, 1808, 1806, 1804, 1788, 1859, 1786, 1857, 1802, 1784, 1529,
  1828, 1855, 1826, 1853, 1782, 1800, 1824, 1851, 1798, 1849, 1822, 1780, 1847,
  1528, 1778, 1820, 1845, 1796, 1818, 1843, 1841, 1794, 1839, 1792, 1837, 1776,
  1816, 1774, 1835, 1814, 1772, 1790, 1833, 1812, 1831, 1770, 1829, 1559, 1810,
  1807, 1563, 1805, 1803, 1787, 1785, 1801, 1783, 1827, 1530, 1825, 1564, 1781,
  1799, 1823, 1797, 1821, 1779, 1524, 1531, 1777, 1819, 1795, 1817, 1793, 1791,
  1523, 1775, 1815, 1773, 1813, 1771, 1789, 1811, 1522, 1769, 1548, 1809, 1521,
  1553, 1554, 1520, 1519, 1535, 1536, 1518, 3195, 1537, 1538, 1539, 1540, 1542,
  1517, 1541,
]; // sales-assisted

export const PREVIOUS_DEFAULT_PG_83_PROD_PLAN_IDS = [
  1008, 1006, 1004, 988, 986, 1002, 984, 1028, 1026, 982, 1024, 1000, 1062,
  1022, 980, 978, 1020, 996, 1018, 994, 992, 976, 1016, 974, 1014, 990, 972,
  1012, 970, 719, 1010, 1007, 723, 1005, 1083, 1003, 987, 393, 985, 1001, 983,
  1027, 1025, 724, 981, 1023, 999, 1061, 1021, 979, 391, 977, 1019, 995, 1017,
  1073, 993, 991, 340, 975, 1015, 973, 1072, 1013, 971, 989, 1011, 338, 969,
  1071, 708, 1009, 336, 713, 1070, 1078, 435, 714, 334, 332, 436, 1069, 447,
  1068, 330, 449, 1067, 450, 1066, 451, 452, 454, 453, 328,
]; // self-serve

export const PREVIOUS_DEFAULT_PG_84_PROD_PLAN_IDS = [
  1060, 1058, 1056, 1054, 1052, 1050, 1048, 1046, 1044, 1042, 1040, 1038, 1036,
  1034, 1032, 1030, 1008, 1006, 1004, 988, 1059, 986, 1057, 1002, 984, 1028,
  1055, 1026, 1053, 982, 1000, 1024, 1051, 1062, 1049, 1022, 980, 1047, 978,
  1020, 1045, 996, 1018, 1043, 1041, 994, 1039, 992, 1037, 976, 1016, 974, 1035,
  1014, 972, 990, 1033, 1012, 1031, 970, 1029, 719, 1010, 1007, 723, 1005, 1083,
  1003, 987, 393, 985, 1001, 983, 1027, 1025, 724, 981, 999, 1023, 1061, 1021,
  979, 391, 977, 1019, 995, 1017, 1073, 993, 991, 340, 975, 1015, 973, 1072,
  1013, 971, 989, 1011, 338, 969, 1071, 708, 1009, 336, 713, 1070, 1078, 435,
  714, 334, 332, 436, 1069, 447, 1068, 330, 449, 1067, 450, 1066, 451, 452, 454,
  328, 453,
]; // sales-assisted
